import dayjs from "dayjs";
import React, { useEffect, useState, useCallback } from "react";
import { FaPlus } from "react-icons/fa";
import ToastMessage from "../../utils/mui/righttoptoast";
import api from "../../api/api";
import { useSelector } from "react-redux";
import { Backdrop, CircularProgress } from "@mui/material";
import AddBoxIcon from '@mui/icons-material/AddBox';
import ControlPointIcon from '@mui/icons-material/ControlPoint';
import debounce from "lodash.debounce";
import DrMadhuSign from "../../assets/imaging/madhusign.png";
import { allowedUsers } from '../allowedUsers';

const ArterialModal = ({ ismodal, setIsmodal, data }) => {
  const[isLoading,setIsLoading]=useState(false)

  const [openToast, setOpenToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastSeverity, setToastSeverity] = useState("error");
  const practiseid = window.getPracticeId();
  const [prevExamData, setPrevExamData] = useState([]);
  const [loading, setLoading] = useState(false);

  const formattedDOB = dayjs(data?.dob).format("DD-MM-YYYY");
  const userConfig = useSelector((state) => state.userconfig);
  const calculateAge = (dob) => {
 
    const birthDate = dayjs(dob);
    const today = dayjs();
    return today.diff(birthDate, "year");
  };


  const age = calculateAge(data?.dob);
  const [formData, setFormData] = useState({
    take: "",
    tape: "",
    examDate: dayjs().format("YYYY-MM-DD"),
    requestedby: "DR. MADHU PAMGANAMAMULA",
    technician: "ART MONTANA",
    // history: ['history1', 'history2', 'history3', 'history4','history5', 'history6', 'history7', 'history8'],
    history: [{ value: "", suggestions: [] }],
    RIGHT: "",
    LEFT: "",
    technicianComments: [
      { id: 1, label: '', value: '' },
      { id: 2, label: '', value: '' },
      { id: 3, label: 'ALL VELOCITIES ARE NORMAL', options: [ 'ALL VELOCITIES ARE NORMAL']},
      { id: 4, label: 'NO FOCAL STENOSES', options: [ 'NO FOCAL STENOSES'] },
      { id: 5, label: 'ABI - NORMAL', options: [ 'ABI - NORMAL']},
      { id: 6, label: '', value: '' },
      { id: 7, label: '', value: '' },
      { id: 8, label: '', value: '' }
    ],
  })

const [loadingMessages, setLoadingMessages] = useState([]);
const debouncedApiCall = useCallback(
  debounce(async (value, index) => {
    setLoadingMessages((prev) => {
      const updatedMessages = [...prev];
      updatedMessages[index] = "Loading..."; // Set loading for current index
      return updatedMessages;
    });
    try {
      const response = await api.post(
        `/v1/fhir-mirror/${practiseid}/patient/${data.patientid}/diagnosis/search`,
        {
          searchflag: value,
          limit: 20,
        }
      );

      console.log("API RESPONSE:", response);

      setFormData((prev) => {
        const updatedHistory = [...prev.history];

        let suggestions = [];

        // ✅ HANDLE BOTH CASES (array OR single object)
        if (Array.isArray(response.data)) {
          console.log("API RESPONSE SUGGESTIONS:", response.data);
          suggestions = response.data;
        } else if (response.data) {
          suggestions = [response.data]; // ✅ wrap single object
        }        
        
        updatedHistory[index] = {
          ...updatedHistory[index],
          suggestions,
        };

        return {
          ...prev,
          history: updatedHistory,
        };
      });

    } catch (error) {
      console.error("Error fetching suggestions:", error);
      setLoadingMessages((prev) => {
        const updatedMessages = [...prev];
        updatedMessages[index] = "Error loading data."; // Set error message for the current field
        return updatedMessages;
      });
    } finally {
        // Reset the loading message for the specific index when finished
        setLoadingMessages((prev) => {
          const updatedMessages = [...prev];
          updatedMessages[index] = null; // Reset the loading message
          return updatedMessages;
        });
      }
  }, 500),
  []
);
  


const fetchdata = async () => {

  try {
   setLoading(true);
    const examtype = "ARTERIAL";
    const response = await api.get(
      `/v1/${practiseid}/imaging/patient/${data.patientid}/get-previous-exam/${examtype}`
    );

    if (response?.status === 200 && response?.data?.length > 0) {
      console.log("Raw API Response for Previous Exams:", response.data);
      // const raw = response?.data[0] ? [response.data[0]] : [];
      const raw = response?.data?.map((exam) => {
        let parsedData = {};
        try {
          parsedData = JSON.parse(exam.data);
        } catch (err) {
          console.error("Failed to parse exam.data", err);
        }

        return {
          ...exam,
          parsedData,
        };
      }) || [];

      console.log("Parsed Previous Exam Data:", raw);
      setPrevExamData(raw);
      setLoading(false);
    }
  } catch (error) {
    console.error("Error fetching data:", error);
    setLoading(false);
  }
};

useEffect(() => {
  if (ismodal) {
    fetchdata();
  }
}, [ismodal]);


const handleFillFields = (examDataString) => {
  try {
    // Parse the JSON string into an object
    const examData = JSON.parse(examDataString);

    // Map parsed data to your form fields
    setFormData((prev) => ({
      ...prev,
      take: examData.take || "", // if exists
      tape: examData.tape || "", // if exists
      examDate: examData.examDate || "",

      requestedby: examData.requestedby || "",
      technician: examData.technician || "",

      // History array
      history: examData.pathistory?.map((hist) => ({
        value: hist.value || "",
        suggestions: hist.suggestions || [],
        icd10: hist.icd10 || "",
      })) || [],

      // RIGHT side measurements
      RIGHT: {
        CFA: examData.RIGHT?.CFA || "",
        PFA: examData.RIGHT?.PFA || "",
        SFA: examData.RIGHT?.SFA || "",
        POP: examData.RIGHT?.POP || "",
        PTA: examData.RIGHT?.PTA || "",
        ATA: examData.RIGHT?.ATA || "",
        bpankle: examData.RIGHT?.bpankle || "",
        bpbrach: examData.RIGHT?.bpbrach || "",
        bpabi: examData.RIGHT?.bpabi || "",
      },

      // LEFT side measurements
      LEFT: {
        CFA: examData.LEFT?.CFA || "",
        PFA: examData.LEFT?.PFA || "",
        SFA: examData.LEFT?.SFA || "",
        POP: examData.LEFT?.POP || "",
        PTA: examData.LEFT?.PTA || "",
        ATA: examData.LEFT?.ATA || "",
        bpankle: examData.LEFT?.bpankle || "",
        bpbrach: examData.LEFT?.bpbrach || "",
        bpabi: examData.LEFT?.bpabi || "",
      },

      // Technician comments
      technicianComments: examData.technicianComments || [],
    }));

    console.log("Form populated with previous exam data:", examData);
  } catch (err) {
    console.error("Failed to parse exam data:", err);
  }
};

// const handleChange = (e, section = null, index = null) => {
//   const { name, value } = e.target;

//   if (section === 'RIGHT' || section === 'LEFT') {
//     setFormData((prevData) => ({
//       ...prevData,
//       [section]: {
//         ...prevData[section],
//         [name]: value,  // Updating the field inside RIGHT or LEFT
//       },
//     }));
//   } 
  
//     // ✅ HISTORY - API Call for Suggestions
// else if (section === "history" && index !== null) {
//   const inputValue = value;
//   console.log("Input Value for Suggestions:", inputValue);
//   setFormData((prev) => {
//     const updatedHistory = [...prev.history];

//     updatedHistory[index] = {
//       ...updatedHistory[index],
//       value: inputValue,
//     };

//     // ✅ Ensure last row always exists
//     // const last = updatedHistory[updatedHistory.length - 1];
//     // if (last.value.trim() !== "") {
//     //   updatedHistory.push({ value: "", suggestions: [] });
//     // }

//     return {
//       ...prev,
//       history: updatedHistory,
//     };
//   });

//   if (inputValue.trim()) {
//     debouncedApiCall(inputValue, index);
//   } else {
//     setFormData((prev) => {
//       const updatedHistory = [...prev.history];
//       updatedHistory[index].suggestions = [];
//       return { ...prev, history: updatedHistory };
//     });
//   }
// }

//   else if (section === 'technicianComments' && index !== null) {
//     const updatedComments = [...formData.technicianComments];
//     updatedComments[index].value = value;
//     setFormData((prevData) => ({
//       ...prevData,
//       technicianComments: updatedComments,
//     }));
//   } else {
//     setFormData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//   }
// };

const handleChange = (e, section = null, index = null, type = null, customValue = null) => {
  // const value = customValue ?? e?.target?.value ?? '';
  const value = customValue ?? (e?.target?.type === 'checkbox' ? e.target.checked : e?.target?.value ?? '');
  const name = e?.target?.name ?? null;

  // RIGHT / LEFT
  if (section === 'RIGHT' || section === 'LEFT') {
    setFormData(prev => ({
      ...prev,
      [section]: {
        ...prev[section],
        [name]: value,
      },
    }));
  }

  // HISTORY
  else if (section === 'history' && index !== null) {
    setFormData(prev => {
      const updated = [...prev.history];
      updated[index] = {
        ...updated[index],
        value,
      };
      return { ...prev, history: updated };
    });

    if (value.trim()) {
      debouncedApiCall(value, index);
    } else {
      setFormData(prev => {
        const updated = [...prev.history];
        updated[index].suggestions = [];
        return { ...prev, history: updated };
      });
    }
  }

  // TECHNICIAN COMMENTS
else if (section === 'technicianComments' && index !== null) {
  setFormData(prev => {
    const updated = [...prev.technicianComments];

    if (type === 'dropdown') {
      updated[index] = {
        ...updated[index],
        dropdown: value,
        text: value, // ✅ auto-fill right side
      };
    } else if (type === 'text') {
      updated[index] = {
        ...updated[index],
        text: value,
      };
    } else {
      updated[index] = {
        ...updated[index],
        value: value,
      };
    }

    return { ...prev, technicianComments: updated };
  });
}

  // NORMAL FIELDS
  else {
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  }
};


const handleSelectSuggestion = (item, index) => {
  const concatenatedValue = `${item.condition_name}  ${item.icd10}`;

  setFormData((prev) => {
    const updatedHistory = [...prev.history];

    updatedHistory[index] = {
      ...updatedHistory[index],
      value: concatenatedValue, // Use the concatenated value as input value
      suggestions: [],
    };

    // Ensure the last row is always empty for manual input
    const last = updatedHistory[updatedHistory.length - 1];
    if (last.value.trim() !== "") {
      updatedHistory.push({ value: "", suggestions: [] });
    }

    return {
      ...prev,
      history: updatedHistory,
    };
  });
};


  // Handle "Add Manually" button click to add a new input field
  const handleAddManually = () => {
    setFormData(prev => {
      const updatedHistory = [...prev.history];
      updatedHistory.push({ value: '', suggestions: [] }); // Add new empty input field
      return { ...prev, history: updatedHistory };
    });
  };


const validateForm = () => {
    const errors = [];

    if (!formData.examDate) errors.push("Exam Date is required.");
    //if (!formData.history.trim()) errors.push("Patient History is required.");


    return errors;
  };

  // Reset form data
  const resetFormData = () => {
    setFormData({
    take: "",
    tape: "",
    examDate: dayjs().format("YYYY-MM-DD"),
    requestedby: "",
    technician: "",
    signoff: "",
    history: [
      { id: 1, label: '', value: '' },
      { id: 2, label: '', value: '' },
      { id: 3, label: '', value: '' },
      { id: 4, label: '', value: '' },
      { id: 5, label: '', value: '' },
      { id: 6, label: '', value: '' },
      { id: 7, label: '', value: '' },
      { id: 8, label: '', value: '' }
    ],
    RIGHT: "",
    LEFT: "",
    technicianComments: [
      { id: 1, label: '', value: '' },
      { id: 2, label: '', value: '' },
      { id: 3, label: 'ALL VELOCITIES ARE NORMAL', value: '' },
      { id: 4, label: 'NO FOCAL STENOSES', value: '' },
      { id: 5, label: 'ABI - NORMAL', value: '' },
      { id: 6, label: '', value: '' },
      { id: 7, label: '', value: '' },
      { id: 8, label: '', value: '' }
    ],
    });
  };

const handleSave = async() => {
  const errors = validateForm();
  if (errors.length > 0) {
    setToastMessage(errors[0]);
    setToastSeverity("error");
    setOpenToast(true);
  } else {
    try {
      setIsLoading(true)
    
    const payload = {
      patient_id: data?.patientid,
      pat_name: `${data?.firstname} ${data?.lastname}`,
      pat_dob: data?.dob,
      examDate: formData.examDate,
      pat_age: age,
      pat_gender: data?.gender?.toUpperCase(),
      encounterid: data?.appointmentid,
      pathistory: formData.history,
      take: formData.take,
      tape: formData.tape,
      requestedby: formData.requestedby,
      technician: formData.technician,
      RIGHT: formData.RIGHT,
      LEFT:formData.LEFT,
      technicianComments: formData.technicianComments,
      signoff: formData?.signoff || '', 
    };
    const user=await api.get('/auth/me')
    const [year, month, day] = formData.examDate.split("-");
    const formattedDate = `${month}/${day}/${year}`;


const response = await api.post(`/v1/${practiseid}/patient/${data.patientid}/imaging/insert-db`, {
  "Worksheet_Type": "ARTERIAL",
  "createdby": user?.username || '',
  "appurl": window.location.origin,
    // "appurl": "",
  "Exam_Date": formattedDate,
  "data": payload
});

if(response.status==200){
  const pdf=await api.post(`/v1/${practiseid}/patient/${data.patientid}/imaging/generate-pdf`,{
  "filename": response?.data?.filename,
  "documenttypeid": response?.data?.documenttypeid,
  "worksheet_type": "ARTERIAL",
  "appurl": window.location.origin,
  "exam_date": formattedDate
  })
  setToastMessage("Form Submitted Successfully");
    setToastSeverity("success");
    setOpenToast(true);
 setTimeout(() => {
  resetFormData()
  setIsmodal(false);
}, 1000);

}else{
  setToastMessage(response.message);
    setToastSeverity("info");
    setOpenToast(true);
}
    } catch (error) {
      console.log(error)
        setToastMessage("Something Went Wrong");
    setToastSeverity("error");
    setOpenToast(true);
    }finally{
setIsLoading(false)

    }
  }
};




  if (!ismodal) return null;


    return (
    <div className="fixed inset-0 z-50 flex items-start justify-center bg-black bg-opacity-50 overflow-y-auto min-h-screen px-2 py-6">
      <div className="w-full max-w-4xl text-start bg-white rounded-lg p-6 shadow-xl relative">
        {/* Header */}
        <div className="flex justify-between items-center mb-2">
          <h2 className="text-lg font-semibold">ARTERIAL</h2>
          <button onClick={() => setIsmodal(false)} className="text-xl font-bold text-gray-500 hover:text-black">
            &times;
          </button>
        </div>
        <hr className="mb-4 border-gray-300" />

        {/* Patient Info */}
        <div className="flex items-center space-x-4 mb-4">
          <img

            src={`/cloud-assets/chim/public/assets/images/profilepictures/${data.patientid}.png`}
            alt="User"
            className="w-16 h-full max-h-28 rounded-md object-cover"
          />
          <div className="space-y-1">
          <div className="text-white bg-violet-500 rounded-lg px-1.5 py-0.5 text-xs font-medium inline-block">
  #{data?.patientid}
</div>

            <div className="text-base font-semibold">{data?.firstname + " " + data?.lastname}</div>
            <div className="text-sm text-gray-700">
              <span className="font-semibold">Date of Birth:</span> {formattedDOB}
            </div>
            <div className="text-sm text-gray-700">
              <span className="font-semibold"   >Age:</span> {age} &nbsp;|&nbsp;
              <span className="font-semibold">Gender:</span> {data?.gender === "M" ? "Male" : "Female"}
            </div>
          </div>
        </div>


{prevExamData.length > 0 && (
<table className="min-w-full text-sm text-left border border-gray-300">
      
        <thead className="bg-gray-200">
          <tr>
            <th colSpan="7" className="border px-3 py-2 font-semibold text-[#8B1818] text-center">Previous Exam Data</th>
          </tr>
          <tr>
            <th className="border px-3 py-2 font-semibold text-[#8B1818]">ID</th>
            <th className="border px-3 py-2 font-semibold text-[#8B1818]">Exam</th>
            <th className="border px-3 py-2 font-semibold text-[#8B1818]">Patient ID</th>
            <th className="border px-3 py-2 font-semibold text-[#8B1818]">Date of Service</th>
            <th className="border px-3 py-2 font-semibold text-[#8B1818]">Created By</th>
            <th className="border px-3 py-2 font-semibold text-[#8B1818]">Action</th>
          </tr>
        </thead>
      

      <tbody className="border divide-y divide-gray-200">
        {prevExamData.length > 0 ? (
          prevExamData.map((exam) => (
            <tr key={exam.id} className="border hover:bg-gray-50">
              <td className="border px-3 py-2">{exam.id}</td>
              <td className="border px-3 py-2">{exam.exam}</td>
              <td className="border px-3 py-2">{exam.patientid}</td>
              <td className="border px-3 py-2">{exam.dateofservice ? dayjs(exam.dateofservice).format("MM-DD-YYYY") : ""}</td>
              <td className="border px-3 py-2">{exam.createdby}</td>
              <td className="border px-3 py-2">
                  <AddBoxIcon onClick={() => handleFillFields(exam.data)} className="cursor-pointer text-gray-700 hover:text-gray-900" />
              </td>
            </tr>
          ))
        ) : (
          <tr>
              <td colSpan="7" className="border px-3 py-2 text-center text-gray-500">
                {loading ? "Getting Records ..." : " No records found"}
              </td>
          </tr>
        )}
      </tbody>
    </table>
)}


{/* Chart  */}
        <div className="grid grid-cols-4 gap-4 py-4">
            <div>
                <label className="block text-sm font-medium mb-1">Chart #</label>
                <input
                type="number"
                step="0.01"
                inputMode="decimal"
                className="border rounded px-2 py-1 w-full"
                value={data?.patientid} readOnly
                />
            </div>
            <div>
                <label className="block text-sm font-medium mb-1">Take</label>
                <input
                type="text"
                name="take" 
                className="border rounded px-2 py-1 w-full"
                value={formData.take} 
                onChange={handleChange}
                />
            </div>
            <div>
                <label className="block text-sm font-medium mb-1">Tape</label>
                <input
                type="text"
                name="tape"
                className="border rounded px-2 py-1 w-full"
                value={formData.tape} 
                onChange={handleChange}
                />
            </div>
          <div>
            <label className="block text-sm font-medium mb-1">Date(mm/dd/yyyy)</label>
            <input
              type="date"
              name="examDate"
              className="w-full border rounded px-2 py-1"
              value={formData.examDate}
              onChange={handleChange}
            />
          </div>
        </div>

        {/* Registered and Technician */}
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">Requested by</label>
            <input
                type="text"
                value={formData.requestedby}
                name="requestedby"
                onChange={handleChange}
                className="w-full border rounded px-2 py-1"
            />
          </div>
       
          <div>
            <label className="block text-sm font-medium mb-1">Technician</label>
            <input
                type="text"
                value={formData.technician}
                name="technician" 
                onChange={handleChange}
                className="w-full border rounded px-2 py-1"
            />
          </div>
        </div>

        {/* History */}
        {/* <div className="mt-4">
          <label className="block text-sm font-medium"> History</label>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mb-6">
              {formData.history.map((hist, index) => (
                <div key={index}>
                  <input
                    type="text" placeholder="Enter text here..."
                    className="w-full border rounded px-3 py-2 mt-1"
                    value={hist.value || ''}
                    onChange={(e) => handleChange(e, 'history', index)}  
                  />
                </div>
              ))}
            </div>
        </div> */}

   <div>
      <div className="mt-4">
        <div className="flex justify-between items-center">
        <label className="block text-sm font-medium">History</label>

        {/* "Add Manually" Button (only appears once at the top) */}
        {!formData.addManual && (
          <div className="">
            <ControlPointIcon            
            className="w-8 cursor-pointer"
            onClick={handleAddManually}
            alt="+"
          />
          </div>
        )}
        </div>


        <div className="grid grid-cols-1 gap-6 mb-6">
          {formData.history.map((hist, index) => (
            <div key={index} className="relative">

              {/* INPUT FIELD */}
              <input
                type="text"
                placeholder="Enter text here..."
                className="w-full border rounded px-3 py-2 mt-1"
                value={hist?.value || ""}
                onChange={(e) => handleChange(e, "history", index)}
                onInput={(e) => debouncedApiCall(e.target.value, index)} // Trigger API call for suggestions
              />

              {/* Display the loading message for the specific input field */}
              {loadingMessages[index] && (
                <div className="absolute top-full mt-1 text-sm text-gray-500">
                  {loadingMessages[index]}
                </div>
              )}
              
              {/* DROPDOWN (If suggestions exist) */}
              {Array.isArray(hist?.suggestions) && hist.suggestions.length > 0 && (
                <ul className="absolute left-0 top-full mt-1 w-full border max-h-40 overflow-y-auto bg-white shadow-lg rounded z-50">
                  {hist.suggestions.map((item, i) => (
                    <li
                      key={item.id || i}
                      className="px-3 py-2 cursor-pointer hover:bg-gray-200"
                      onClick={() => handleSelectSuggestion(item, index)}
                    >
                      <div className="font-medium">
                        {item?.condition_name || "No Name"}
                      </div>
                      {item?.icd10 && (
                        <div className="text-xs text-gray-500">
                          ICD: {item.icd10}
                        </div>
                      )}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>



    <div className="py-1 mt-3">
      {/* RIGHT Section */}
      <div className="grid grid-cols-2 gap-6 mb-2">
        <div className="border">
          <div className="bg-blue-200 text-black p-1"> :: RIGHT</div>
          <div className="space-y-4 p-2">            
            <div className="flex items-center gap-2">
                <label className="text-sm  mt-2 text-center font-medium text-gray-700">CFA </label>
                <input
                    type="text"
                    name="CFA"
                    className="w-full border rounded px-3 py-2 mt-1"
                    placeholder="cm/s"
                    value={formData.RIGHT?.CFA || ''}
                    onChange={(e) => handleChange(e, 'RIGHT')}
                />
            </div>
            
            <div className="flex items-center gap-2">
                <label className="text-sm  mt-2 text-center font-medium text-gray-700">PFA </label>
                <input
                    type="text"
                    name="PFA"
                    className="w-full border rounded px-3 py-2 mt-1"
                    placeholder="cm/s"
                    value={formData.RIGHT?.PFA || ''}
                    onChange={(e) => handleChange(e, 'RIGHT')}
                />
            </div>

            <div className="flex items-center gap-2">
                <label className="text-sm  mt-2 text-center font-medium text-gray-700"> SFA  </label>
                <input
                    type="text"
                    name="SFA"
                    className="w-full border rounded px-3 py-2 mt-1"
                    placeholder="cm/s"
                    value={formData.RIGHT?.SFA || ''}
                    onChange={(e) => handleChange(e, 'RIGHT')}
                />
            </div>

            <div className="flex items-center gap-2">
                <label className="text-sm  mt-2 text-center font-medium text-gray-700"> POP </label>
                <input
                    type="text"
                    name="POP"
                    className="w-full border rounded px-3 py-2 mt-1"
                    value={formData.RIGHT?.POP || ''}
                    onChange={(e) => handleChange(e, 'RIGHT')}
                    placeholder="cm/s"
                />
            </div>
            <div className="flex items-center gap-2">
                <label className="text-sm  mt-2 text-center font-medium text-gray-700"> PTA </label>
                <input
                    type="text"
                    name="PTA"
                    className="w-full border rounded px-3 py-2 mt-1"
                    placeholder="cm/s"
                    value={formData.RIGHT?.PTA || ''}
                    onChange={(e) => handleChange(e, 'RIGHT')}
                />
            </div>
            <div className="flex items-center gap-2">
                <label className="text-sm  mt-2 text-center font-medium text-gray-700"> ATA </label>
                <input
                    type="text"
                    name="ATA"
                    className="w-full border rounded px-3 py-2 mt-1"
                    placeholder="cm/s"                   
                    value={formData.RIGHT?.ATA || ''}
                    onChange={(e) => handleChange(e, 'RIGHT')}
                />
            </div>

            <div className="flex items-center gap-2 mt-4">
                <label className="text-sm mt-2 font-medium text-gray-700 w-[30%]">BP ANKLE :</label>
                <input
                    type="text"
                    name="bpankle"
                    className="w-full border rounded px-3 py-2 mt-1"
                    value={formData.RIGHT?.bpankle || ''}
                    onChange={(e) => handleChange(e, 'RIGHT')}
                />
            </div>
            <div className="flex items-center gap-2 mt-4">
                <label className="text-sm mt-2 font-medium text-gray-700 w-[30%]">BP BRACH :</label>
                <input
                    type="text"
                    name="bpbrach"
                    className="w-full border rounded px-3 py-2 mt-1"
                    value={formData.RIGHT?.bpbrach || ''}
                    onChange={(e) => handleChange(e, 'RIGHT')}
                />
            </div>
            <div className="flex items-center gap-2 mt-4">
                <label className="text-sm mt-2 font-medium text-gray-700 w-[30%]">BP ABI :</label>
                <input
                    type="text"
                    name="bpabi"
                    className="w-full border rounded px-3 py-2 mt-1"
                    value={formData.RIGHT?.bpabi || ''}
                    onChange={(e) => handleChange(e, 'RIGHT')}
                />
            </div>
          </div>
        </div>

        {/* LEFT Section */}
        <div className="border">
          <div className="bg-blue-200 text-black p-1"> :: LEFT</div>
          <div className="space-y-4 p-2">
                        <div className="flex items-center gap-2">
                <label className="text-sm  mt-2 text-center font-medium text-gray-700">CFA </label>
                <input
                    type="text"
                    name="CFA"
                    className="w-full border rounded px-3 py-2 mt-1"
                    placeholder="cm/s"
                    value={formData.LEFT?.CFA || ''}
                    onChange={(e) => handleChange(e, 'LEFT')}
                />
            </div>
            
            <div className="flex items-center gap-2">
                <label className="text-sm  mt-2 text-center font-medium text-gray-700">PFA </label>
                <input
                    type="text"
                    name="PFA"
                    className="w-full border rounded px-3 py-2 mt-1"
                    placeholder="cm/s"
                    value={formData.LEFT?.PFA || ''}
                    onChange={(e) => handleChange(e, 'LEFT')}
                />
            </div>

            <div className="flex items-center gap-2">
                <label className="text-sm  mt-2 text-center font-medium text-gray-700"> SFA  </label>
                <input
                    type="text"
                    name="SFA"
                    className="w-full border rounded px-3 py-2 mt-1"
                    placeholder="cm/s"
                    value={formData.LEFT?.SFA || ''}
                    onChange={(e) => handleChange(e, 'LEFT')}
                />
            </div>

            <div className="flex items-center gap-2">
                <label className="text-sm  mt-2 text-center font-medium text-gray-700"> POP </label>
                <input
                    type="text"
                    name="POP"
                    className="w-full border rounded px-3 py-2 mt-1"
                    value={formData.LEFT?.POP || ''}
                    onChange={(e) => handleChange(e, 'LEFT')}
                    placeholder="cm/s"
                />
            </div>
            <div className="flex items-center gap-2">
                <label className="text-sm  mt-2 text-center font-medium text-gray-700"> PTA </label>
                <input
                    type="text"
                    name="PTA"
                    className="w-full border rounded px-3 py-2 mt-1"
                    placeholder="cm/s"
                    value={formData.LEFT?.PTA || ''}
                    onChange={(e) => handleChange(e, 'LEFT')}
                />
            </div>
            <div className="flex items-center gap-2">
                <label className="text-sm  mt-2 text-center font-medium text-gray-700"> ATA </label>
                <input
                    type="text"
                    name="ATA"
                    className="w-full border rounded px-3 py-2 mt-1"
                    placeholder="cm/s"                   
                    value={formData.LEFT?.ATA || ''}
                    onChange={(e) => handleChange(e, 'LEFT')}
                />
            </div>

            <div className="flex items-center gap-2 mt-4">
                <label className="text-sm mt-2 font-medium text-gray-700 w-[30%]">BP ANKLE :</label>
                <input
                    type="text"
                    name="bpankle"
                    className="w-full border rounded px-3 py-2 mt-1"
                    value={formData.LEFT?.bpankle || ''}
                    onChange={(e) => handleChange(e, 'LEFT')}
                />
            </div>
            <div className="flex items-center gap-2 mt-4">
                <label className="text-sm mt-2 font-medium text-gray-700 w-[30%]">BP BRACH :</label>
                <input
                    type="text"
                    name="bpbrach"
                    className="w-full border rounded px-3 py-2 mt-1"
                    value={formData.LEFT?.bpbrach || ''}
                    onChange={(e) => handleChange(e, 'LEFT')}
                />
            </div>
            <div className="flex items-center gap-2 mt-4">
                <label className="text-sm mt-2 font-medium text-gray-700 w-[30%]">BP ABI :</label>
                <input
                    type="text"
                    name="bpabi"
                    className="w-full border rounded px-3 py-2 mt-1"
                    value={formData.LEFT?.bpabi || ''}
                    onChange={(e) => handleChange(e, 'LEFT')}
                />
            </div>

          </div>
        </div>

      </div>
      </div>

      {/* Technician's  Comments */}
<div className="py-8">
  <h2 className="text-xl font-semibold">
    {allowedUsers.includes(userConfig?.username) ? (
      <div>IMPRESSIONS</div>
    ) : (
      <div>TECHNICIAN COMMENTS</div>
    )}
  </h2>
  <div className="grid gap-6 mb-8">
    <div className="space-y-4">
      {formData.technicianComments.map((comment, index) => (
        <div key={comment.id}>
          {/* Dropdown for id 3, 4, and 5 */}
          {comment.id === 3 || comment.id === 4 || comment.id === 5 ? (
            <div className="grid grid-cols-2 gap-2 py-1">
              <div>
                {/* Dropdown for specific technician comments */}
                <select
                  className="w-full border rounded px-3 py-2 mt-1"
                  value={formData.technicianComments[index].dropdown || ''}
                  onChange={(e) =>
                    handleChange(e, 'technicianComments', index, 'dropdown')
                  }
                >
                  <option value="" >Select an option</option>
                  {comment.options?.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <div className=""
                  role="textbox"                  
                >
                  {/* {comment.label} */}
                   <input
                    type="text"
                    className="w-full border rounded px-3 py-2 mt-1"
                    value={formData.technicianComments[index].text || ''}
                    onChange={(e) =>
                      handleChange(e, 'technicianComments', index, 'text')
                    }
                  />
                </div>
              </div>
            </div>
          ) : (
            <div>
              {/* For non-dropdown comments, use a textarea */}
              <label className="block text-sm font-medium text-gray-700">
                {comment.label}
              </label>
              <textarea
                placeholder="Enter Comments here..."
                name="technicianComments"
                rows={3}
                className="w-full border rounded px-2 py-1 mt-1"
                value={formData.technicianComments[index]?.value || ''}
                onChange={(e) => handleChange(e, 'technicianComments', index)}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  </div>
</div>

    <div className="py-8">
      {/* Action Buttons */}
      <div className="flex justify-between items-center">

        {allowedUsers.includes(userConfig?.username) ? (
          <div className="flex flex-col items-start p-4 bg-white shadow-md rounded-lg border border-gray-200 w-80">
            <label className="flex items-center cursor-pointer">
              <input
                type="checkbox"
                name="signoff"
                checked={formData.signoff || false}
                onChange={handleChange}
                className="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
              />
              <span className="ml-3 font-semibold text-gray-700 text-lg">Sign Off</span>
            </label>

            {formData.signoff && (
              <>
                <div className="mt-3 flex items-center space-x-3">
                  <img
                    src={DrMadhuSign}
                    alt="Signed Off"
                    className="h-20 rounded-lg shadow-md animate-fadeIn"
                  />
                  <span className="text-green-600 font-medium">Successfully Signed!</span>
                </div>
                <div className="py-2 font-semibold">Dr. Madhu Pamganamamula MD FACP FASPC DABOM DABCL CCD</div>
              </>
            )}
          </div>
        ) : (
          <div className=""></div>
        )}
        <div>
          <button
            onClick={handleSave}
            className="bg-blue-500 text-white px-6 py-2 rounded-md hover:bg-blue-600"
          >
            Save Report
          </button>
          {/* <button            
            className="bg-green-500 text-white px-6 py-2 rounded-md hover:bg-green-600 ml-4"
          >
            Update Report
          </button> */}
          <button            
            className="bg-gray-500 text-white px-6 py-2 rounded-md hover:bg-gray-600 ml-4"
          >
            Clear Data
          </button>
        </div>

      </div>
    </div>

    
</div>

   <Backdrop
  sx={{
    color: '#fff',
    zIndex: (theme) => theme.zIndex.drawer + 1,
    backgroundColor: 'rgba(0, 0, 0, 0.7)', // reduced opacity (default is 0.5)
  }}
  open={isLoading}
>
  <CircularProgress color="inherit" />
</Backdrop>
      <ToastMessage
        message={toastMessage}
        severity={toastSeverity}
        open={openToast}
        handleClose={() => setOpenToast(false)}
      />
    </div>
  );
};

export default ArterialModal;
